import '@polymer/paper-button/paper-button';
import '../../../../neb-material-design/src/components/neb-md-button';
import '../../store/online-booking/neb-online-booking-state';
import '../neb-booking-appointment-details';
import '../../../../neb-lit-components/src/components/neb-progress-tracker';
import '../date-time/neb-booking-date-page';
import '../review-confirm/neb-review-confirm-page';
import '../../../../neb-lit-components/src/components/neb-button';

import { openPopup } from '@neb/popup';
import { matchRouteSwitch } from '@neb/router';
import { LitElement, html, css } from 'lit';

import { navigate } from '../../../../../src/store';
import { getBookingAppointment } from '../../../../neb-api-client/src/appointment-api-client';
import { getAppointmentTypeLocationPublic } from '../../../../neb-api-client/src/appointment-types';
import {
  cancelAppointment,
  rescheduleAppointment,
} from '../../../../neb-calendar/neb-appointments-state-public';
import {
  openSuccess,
  openError,
} from '../../../../neb-dialog/neb-banner-state';
import { POPUP_RENDER_KEYS } from '../../../../neb-popup/src/renderer-keys';
import { store, connect } from '../../../../neb-redux/neb-redux-store';
import { OnlineBookingConfigService } from '../../../../neb-redux/services/online-booking-config';
import { renderStyles } from '../../../../neb-styles/neb-styles';
import {
  CSS_SPACING,
  CSS_COLOR_HIGHLIGHT,
  CSS_FONT_FAMILY,
} from '../../../../neb-styles/neb-variables';
import { parseDate } from '../../../../neb-utils/date-util';
import { CORE_API_URL } from '../../../../neb-utils/env';
import { objToName, DEFAULT_NAME_OPTS } from '../../../../neb-utils/formatters';
import {
  newAppointment,
  updateBookingPage,
} from '../../store/booking/bookingAction';
import { appointmentTypeCanBeScheduled } from '../util/enable-booking-util';

import { createGoogleCalendarEvent } from './google-calendar-helper';

export const ELEMENTS = {
  downloadLink: { id: 'link-download' },
  policyNotice: { id: 'policy-notice' },
  cancelReschedule: { id: 'cancel-reschedule' },
  bookAnotherButton: { id: 'button-book-another' },
  addToGoogleButton: { id: 'button-add-to-google' },
  addToCalendarButton: { id: 'button-add-to-calendar' },
  reviewConfirmPage: { id: 'review-confirm-page' },
  rescheduleButton: { id: 'rescheduleButton' },
  bookingDatePage: { id: 'booking-date-page' },
  backButton: { id: 'back-button' },
  backIcon: { id: 'back-icon' },
  cancelButton: { id: 'cancelButton' },
  viewMyAppointmentsButton: { id: 'view-my-appointments-button' },
  appointmentDetails: { id: 'appointmentDetails' },
};

export const TEXT_RESCHEDULE_SUCCESS = 'Appointment Rescheduled';
export const TEXT_RESCHEDULE_ERROR = 'Unable to reschedule appointment';
const TEXT_BOOK_ANOTHER_BUTTON = 'Book Another Appointment';
const TEXT_VIEW_APPOINTMENTS_BUTTON = 'View My Appointments';
export const TEXT_APPOINTMENT_NOT_EXIST = 'Appointment does not exist!';

export const UNAVAILABLE_LOCATION = {
  name: 'Location Unavailable',
  active: false,
};

const PROGRESS_ITEMS = ['Service', 'Date & Time', 'Your info', 'Confirmation'];

class NebBookingAppointmentPage extends connect(store)(LitElement) {
  static get properties() {
    return {
      __allowCancelReschedule: Boolean,
      __appointment: Object,
      __clientPolicyNotice: String,
      __providers: Object,
      __token: String,
      __updatedAppointment: Object,
      __appointmentTypeLocations: Array,
      enableBooking: Boolean,

      apiPrefix: String,
      appointmentId: String,
      availableProviders: Array,
      isReschedule: Boolean,
      layout: {
        type: String,
        reflect: true,
      },
      route: String,
      tenantPracticeInfo: Object,
      tenantShortName: String,
      user: Object,
    };
  }

  static get styles() {
    return css`
      :host {
        display: flex;
        flex-direction: column;
        margin: 0 25px;
      }

      :host([layout='small']) {
        margin: 0;
      }

      :host([layout='small']) .date-page {
        margin: ${CSS_SPACING} 0;
      }

      .appointment-details {
        margin-top: ${CSS_SPACING};
        margin-bottom: ${CSS_SPACING};
      }

      .add-to-calendar-button,
      .add-to-google-button {
        margin-bottom: ${CSS_SPACING};
        margin-right: ${CSS_SPACING};
      }

      .reschedule-cancel {
        display: flex;
        margin-left: -11px;
      }

      :host([layout='small']) .reschedule-cancel {
        flex-wrap: wrap;
        margin-top: ${CSS_SPACING};
      }

      .policy-title {
        font-weight: bold;
        margin-top: ${CSS_SPACING};
      }

      .button-container {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
      }

      .button {
        flex-shrink: 0;
        margin-top: ${CSS_SPACING};
        margin-right: ${CSS_SPACING};
      }

      .progress-tracker {
        margin-bottom: 25px;
      }

      :host([layout='small']) .progress-tracker {
        margin: 40px ${CSS_SPACING} ${CSS_SPACING};
      }

      .icon-back {
        align-self: center;
        transform: rotate(90deg);
        width: 12px;
        height: 12px;
      }

      .icon-back > svg {
        fill: ${CSS_COLOR_HIGHLIGHT};
      }

      .desktop-back-container {
        padding-top: ${CSS_SPACING};
        padding-left: ${CSS_SPACING};
        color: ${CSS_COLOR_HIGHLIGHT};
        font-weight: bold;
      }

      .desktop-back-container > div {
        cursor: pointer;
        width: 100px;
      }

      .appointment-container {
        font-family: ${CSS_FONT_FAMILY};
        font-weight: bold;
      }

      .neb-button-text {
        text-decoration: underline;
      }
    `;
  }

  get __hasRequestParams() {
    return this.__hasTenantId && this.__hasToken && this.appointmentId;
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.__appointment = {};
    this.__clientPolicyNotice = null;
    this.__fetchedOnInitialLoad = false;
    this.__hasTenantId = false;
    this.__hasToken = false;
    this.__hasSession = false;
    this.__navItems = this.__genNavItems();
    this.__oldAppointmentId = '';
    this.__token = window.localStorage.getItem('neb-login-local');
    this.__updatedAppointment = {};
    this.__appointmentTypeLocations = [];

    this.apiPrefix = '';
    this.appointmentId = '';
    this.enableBooking = false;
    this.isReschedule = false;
    this.layout = '';
    this.route = '';
    this.tenantPracticeInfo = {};
    this.tenantShortName = '';
    this.user = {};

    this.onNavigateToLogin = () => {};

    this.__configService = new OnlineBookingConfigService(bookingConfig => {
      this.__clientPolicyNotice = bookingConfig.clientPolicyNotice;
      this.__allowCancelReschedule =
        bookingConfig.allowCancelReschedule && !this.__appointment.checkedInAt;
    });
  }

  __initHandlers() {
    this.__handlers = {
      addToGoogle: () => {
        createGoogleCalendarEvent(
          this.__appointment,
          this.tenantPracticeInfo,
          `${this.__getProvider().lastName}, ${this.__getProvider().firstName}`,
          this.__getLocation(),
          window.location.href,
        );
      },
      cancel: async () => {
        try {
          const result = await openPopup(POPUP_RENDER_KEYS.CONFIRM, {
            title: 'Are you sure you want to cancel your appointment?',
            message: '',
            confirmText: 'Yes',
            cancelText: 'No',
          });

          if (result) {
            await store.dispatch(cancelAppointment(this.__appointment));
            store.dispatch(openSuccess('Appointment Canceled'));
            navigate('#/my-appointments');
          }
        } catch (e) {
          store.dispatch(openError('Unable to cancel appointment'));
        }
      },
      reschedule: () => {
        store.dispatch(updateBookingPage('date'));
        navigate(`#/appointment/${this.__appointment.id}/reschedule`);
      },
      bookAnother: () => {
        store.dispatch(updateBookingPage(''));
        store.dispatch(newAppointment({}));

        navigate('#/book-appointment');
      },
      rescheduleAppointmentFormComplete: data => {
        const duration = parseDate(this.__appointment.end).diff(
          parseDate(this.__appointment.start),
        );

        const newAppointmentEnd = parseDate(data.start).add(
          duration,
          'milliseconds',
        );
        this.__updatedAppointment = {
          ...this.__appointment,
          ...data,
          end: newAppointmentEnd.toDate(),
          duration,
        };

        navigate(`#/appointment/${this.__appointment.id}/reschedule/confirm`);
      },
      rescheduleAppointmentBook: async () => {
        try {
          const appointment = await store.dispatch(
            rescheduleAppointment(this.__updatedAppointment),
          );
          this.__appointment = { ...this.__appointment, ...appointment };
          store.dispatch(openSuccess(TEXT_RESCHEDULE_SUCCESS));
          navigate(`#/appointment/${appointment.id}`);
        } catch (e) {
          store.dispatch(openError(TEXT_RESCHEDULE_ERROR));
        }
      },
      cancelReschedule: () => {
        navigate(`#/appointment/${this.__appointment.id}`);
      },
      navigateToMyAppointments: () => {
        navigate('#/my-appointments');
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();

    this.__configService.connect();
  }

  disconnectedCallback() {
    this.__configService.disconnect();

    super.disconnectedCallback();
  }

  _stateChanged(state) {
    if (state.session && state.session.item) {
      this.__hasSession = true;
    }

    if (
      state.providers &&
      state.providers.item &&
      this.__providers !== state.providers.item
    ) {
      this.__providers = state.providers.item;
    }

    if (
      state.onlineBooking &&
      state.onlineBooking.item &&
      state.onlineBooking.item.tenantId
    ) {
      this.__hasTenantId = true;
    }

    if (state.session.item && state.session.item.idToken) {
      this.__hasToken = true;
    }
  }

  __genNavItems() {
    return [
      {
        exact: true,
        path: '/',
        resolver: () => this.__renderCurrentAppointment(),
      },
      {
        exact: true,
        path: '/reschedule',
        resolver: () => html`
          <neb-progress-tracker
            class="progress-tracker"
            .items="${PROGRESS_ITEMS}"
            .step="${2}"
            .layout="${this.layout}"
          ></neb-progress-tracker>

          <neb-booking-date-page
            id="${ELEMENTS.bookingDatePage.id}"
            class="date-page"
            .appointment="${this.__appointment}"
            .layout="${this.layout}"
            .onFormCompleted="${this.__handlers
              .rescheduleAppointmentFormComplete}"
          ></neb-booking-date-page>
        `,
      },
      {
        exact: true,
        path: '/reschedule/confirm',
        resolver: () => html`
          <neb-progress-tracker
            class="progress-tracker"
            .items="${PROGRESS_ITEMS}"
            .step="${4}"
            .layout="${this.layout}"
          ></neb-progress-tracker>

          <neb-review-confirm-page
            id="${ELEMENTS.reviewConfirmPage.id}"
            class="selected-page"
            .appointment="${this.__updatedAppointment}"
            .layout="${this.layout}"
            .user="${this.user}"
            .provider="${this.__getUpdatedProvider()}"
            .locations="${this.tenantPracticeInfo.locations}"
            .isReschedule="${this.isReschedule}"
            .onAppointmentBooked="${this.__handlers.rescheduleAppointmentBook}"
          ></neb-review-confirm-page>
        `,
      },
    ];
  }

  async __fetchBookingAppointment() {
    try {
      this.__appointment = await getBookingAppointment(this.appointmentId);

      this.__configService.update(parseDate(this.__appointment.start).toDate());
    } catch (e) {
      store.dispatch(openError(TEXT_APPOINTMENT_NOT_EXIST));
      navigate('#/my-appointments');
    }
  }

  __getProvider() {
    if (!this.__providers) return {};
    return this.__providers.find(p => p.id === this.__appointment.providerId);
  }

  __getUpdatedProvider() {
    if (!this.__providers) return {};
    return this.__providers.find(
      p => p.id === this.__updatedAppointment.providerId,
    );
  }

  __getLocation() {
    if (!this.tenantPracticeInfo.locations || !this.__appointment.locationId) {
      return null;
    }

    const location = this.tenantPracticeInfo.locations.find(
      l => l.id === this.__appointment.locationId,
    );

    if (!location) return UNAVAILABLE_LOCATION;

    return this.tenantPracticeInfo.locations.length > 1 ? location : null;
  }

  __getProviderName() {
    const provider = this.__getProvider();
    if (!provider) return '';

    return objToName(provider.name, DEFAULT_NAME_OPTS);
  }

  __getCalendarDownloadHref() {
    const { tenantShortName, appointmentId } = this;
    const providerName = this.__getProviderName();

    return `${CORE_API_URL}/public/v1/${tenantShortName}/${appointmentId}/downloadVCalendar?link=${encodeURIComponent(
      window.location.href,
    )}&providerName=${providerName}`;
  }

  __canReschedule() {
    return (
      this.__getProvider() &&
      !this.__appointment.walkIn &&
      !this.__appointment.appointmentSplitCount &&
      this.enableBooking &&
      appointmentTypeCanBeScheduled(
        this.__appointment.appointmentTypeId,
        this.__appointmentTypeLocations,
        store.getState(),
      )
    );
  }

  __renderCurrentAppointment() {
    const location = this.__getLocation();

    return html`
      <div class="appointment-container">
        <div id="title" class="neb-font-header-highlight">
          Appointment Confirmed
        </div>

        <neb-booking-appointment-details
          id="${ELEMENTS.appointmentDetails.id}"
          class="appointment-details"
          .layout="${this.layout}"
          .appointment="${this.__appointment}"
          .provider="${this.__getProvider()}"
          .location="${this.__getLocation()}"
          showserviceinfo
        ></neb-booking-appointment-details>

        <div class="calendarButtonsContainer">
          ${
            !location || location.active
              ? html`
                  <a
                    id="${ELEMENTS.downloadLink.id}"
                    href="${this.__getCalendarDownloadHref()}"
                    target="_blank"
                  >
                    <neb-button
                      id="${ELEMENTS.addToCalendarButton.id}"
                      class="add-to-calendar-button"
                      label="Add to Calendar / Outlook"
                    ></neb-button>
                  </a>
                  <neb-button
                    id="${ELEMENTS.addToGoogleButton.id}"
                    class="add-to-google-button"
                    label="Add to Google Calendar"
                    .onClick="${this.__handlers.addToGoogle}"
                  ></neb-button>
                `
              : html`
                  <neb-button
                    id="${ELEMENTS.addToCalendarButton.id}"
                    class="add-to-calendar-button"
                    label="Add to Calendar / Outlook"
                    disabled
                  ></neb-button>
                  <neb-button
                    id="${ELEMENTS.addToGoogleButton.id}"
                    class="add-to-google-button"
                    label="Add to Google Calendar"
                    disabled
                  ></neb-button>
                `
          }
        </div>

        ${
          this.__allowCancelReschedule
            ? html`
                <div
                  id="${ELEMENTS.cancelReschedule.id}"
                  class="reschedule-cancel"
                >
                  ${this.__canReschedule()
                    ? html`
                        <paper-button
                          id="${ELEMENTS.rescheduleButton.id}"
                          class="neb-button-text"
                          @click="${this.__handlers.reschedule}"
                          >Reschedule Appointment</paper-button
                        >
                      `
                    : ''}

                  <paper-button
                    id="${ELEMENTS.cancelButton.id}"
                    class="neb-button-text"
                    @click="${this.__handlers.cancel}"
                    >Cancel Appointment</paper-button
                  >
                </div>
              `
            : ''
        }
        ${
          this.__clientPolicyNotice
            ? html`
                <div id="cancelPolicyContainer">
                  <div class="policy-title">Cancellation Policy</div>
                  <div
                    id="${ELEMENTS.policyNotice.id}"
                    class="neb-font-caption-regular"
                  >
                    ${this.__clientPolicyNotice}
                  </div>
                </div>
              `
            : ''
        }

        <div class="button-container">
          ${
            this.enableBooking
              ? html`
                  <neb-md-button
                    id="${ELEMENTS.bookAnotherButton.id}"
                    class="button"
                    label="${TEXT_BOOK_ANOTHER_BUTTON}"
                    @click="${this.__handlers.bookAnother}"
                    outlined
                  ></neb-md-button>
                `
              : ''
          }


          <neb-md-button
            id="${ELEMENTS.viewMyAppointmentsButton.id}"
            class="button"
            label="${TEXT_VIEW_APPOINTMENTS_BUTTON}"
            @click="${this.__handlers.navigateToMyAppointments}"
            outlined
          ></neb-md-button>
        </div>
      </div>
      </div>
    `;
  }

  async updated(changedProps) {
    if (!this.__fetchedOnInitialLoad && this.__hasRequestParams) {
      this.__fetchedOnInitialLoad = true;

      this.__appointmentTypeLocations = await getAppointmentTypeLocationPublic(
        store.getState().booking.tenantShortName,
      );

      return this.__fetchBookingAppointment();
    }

    if (!this.__hasRequestParams && !this.__hasSession && !this.__token) {
      return this.onNavigateToLogin(`/appointment/${this.appointmentId}`);
    }

    if (
      changedProps.has('appointmentId') &&
      this.__hasRequestParams &&
      this.appointmentId !== this.oldAppointmentId
    ) {
      this.oldAppointmentId = this.appointmentId;
      return this.__fetchBookingAppointment();
    }

    return undefined;
  }

  render() {
    return html`
      ${renderStyles()} ${matchRouteSwitch(this.__navItems, this.route)}
    `;
  }
}

customElements.define(
  'neb-booking-appointment-page',
  NebBookingAppointmentPage,
);
